export const apiName: string = 'combustiveis';
export const combustiveisRoute: string = 'combustiveis';
export const combustiveisStorage: string = 'combustiveis';
export const combustiveisModuleName: any = {plural: 'Combustíveis', single: 'Combustível'};


export const combustiveisQuery: any = {
    "where":{
        "ativo":true,
        "combustivel":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"combustivel"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/shared/data.service.ts
 **/